import round from 'utils/round';
import moment from 'moment';
import 'moment-duration-format';
import React from 'react';

export function formatDuration(duration) {
  // special case. between 1 and 59 seconds is transformed to 1 minute.
  const seconds = duration.asSeconds();
  if (seconds > 0 && seconds < 60) {
    duration = moment.duration(1, 'minutes');
  }
  return duration.format('h:mm', {trim: false});
}

export function formatHours(hoursAsFloat) {
  if (hoursAsFloat === 0) {
    return 0;
  } else if (hoursAsFloat < 0.1) {
    return hoursAsFloat.toFixed(2);
  } else if (hoursAsFloat < 3) {
    // 3 is arbitrary
    return hoursAsFloat.toFixed(1);
  } else {
    return hoursAsFloat.toFixed(0);
  }
}

export function fractionToPercentage(fraction) {
  return round(fraction * 100, 0);
}

export function rankData(previousRank, currentRank) {
  if (currentRank == null) {
    return {
      rank: null,
      delta: null,
    };
  }
  const delta = previousRank ? previousRank.rank - currentRank.rank : 0;
  return {
    rank: currentRank.rank,
    delta,
  };
}

export function trendFromRanks(previousRank, currentRank) {
  if (previousRank == null || currentRank == null) {
    // need to have both endpoints for a trend. Return 0 instead.
    return 0;
  }
  // Less accurate to round before doing math, but users don't see discrepancies this way.
  const previousValue = round(previousRank.value || 0, 0);
  const currentValue = round(currentRank.value || 0, 0);
  return {
    previousValue,
    currentValue,
    trend: currentValue - previousValue,
  };
}

export function trendTooltip(trend) {
  return (
    <div>
      <div>Previous period: {trend.previousValue}%</div>
      <div>Current period: {trend.currentValue}%</div>
    </div>
  );
}
